import React, { FunctionComponent } from 'react'
import { MobileSearchBar, MobileSearchContainer, MobileInputSearch, MobileSearchHistory } from './styles'
import { MobileIconContainer } from '../Header/style'
import config from "../../config/enviroment";
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';

type MobileSearchProps = {
    show: boolean;
    color?: string,
    onClose: () => void,
    onSearch: (event: React.SyntheticEvent) => void | ((search: string) => void),
    history?: [],
    searchValue: string,
    handleChangeSearch: (e:string) => void
}

const MobileSearch: FunctionComponent<MobileSearchProps> = ({ show = false, color = '#999999', onClose, onSearch, history = [], searchValue, handleChangeSearch }) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    return (
        <MobileSearchContainer show={show}>
            <MobileSearchBar onSubmit={onSearch}>
                <MobileIconContainer onClick={onClose}>
                    <svg data-src={`${config.urlMultimedia}/vende/landing-img/arrowLeft.svg`} fill={'#8C8C91'}/>
                </MobileIconContainer>
                <MobileInputSearch type="text" value={searchValue} onChange={(e) => handleChangeSearch(e.target.value)} name="searchEpayco" autoComplete="off" autoFocus placeholder={language[homeState.default_language]["placeholderSearch"]} />
            </MobileSearchBar>
            <MobileSearchHistory>
                <ul>
                    {history.map((item) => 
                    (<li onClick={() => onSearch(item)} key={item}>
                        <svg data-src={`${config.urlMultimedia}/vende/landing-img/clock.svg`} />
                        <span>{item}</span>
                    </li>))}
                </ul>
            </MobileSearchHistory>
        </MobileSearchContainer>
    )
}

export default MobileSearch